"use strict";

var _classCallCheck = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/inherits");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var Node_1 = __importDefault(require("./Node"));

var embeds_1 = __importDefault(require("../rules/embeds"));

var cache = {};

var Embed =
/*#__PURE__*/
function (_Node_1$default) {
  _inherits(Embed, _Node_1$default);

  function Embed() {
    _classCallCheck(this, Embed);

    return _possibleConstructorReturn(this, _getPrototypeOf(Embed).apply(this, arguments));
  }

  _createClass(Embed, [{
    key: "component",
    value: function component(_ref) {
      var isEditable = _ref.isEditable,
          isSelected = _ref.isSelected,
          theme = _ref.theme,
          node = _ref.node;
      var embeds = this.editor.props.embeds;
      var hit = cache[node.attrs.href];
      var Component = hit ? hit.Component : undefined;
      var matches = hit ? hit.matches : undefined;

      if (!Component) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = embeds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var embed = _step.value;
            var m = embed.matcher(node.attrs.href);

            if (m) {
              Component = embed.component;
              matches = m;
              cache[node.attrs.href] = {
                Component: Component,
                matches: matches
              };
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      if (!Component) {
        return null;
      }

      return React.createElement(Component, {
        attrs: Object.assign(Object.assign({}, node.attrs), {
          matches: matches
        }),
        isEditable: isEditable,
        isSelected: isSelected,
        theme: theme
      });
    }
  }, {
    key: "commands",
    value: function commands(_ref2) {
      var type = _ref2.type;
      return function (attrs) {
        return function (state, dispatch) {
          dispatch(state.tr.replaceSelectionWith(type.create(attrs)).scrollIntoView());
          return true;
        };
      };
    }
  }, {
    key: "toMarkdown",
    value: function toMarkdown(state, node) {
      state.ensureNewLine();
      state.write("[" + state.esc(node.attrs.href) + "](" + state.esc(node.attrs.href) + ")");
      state.write("\n\n");
    }
  }, {
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        node: "embed",
        getAttrs: function getAttrs(token) {
          return {
            href: token.attrGet("href")
          };
        }
      };
    }
  }, {
    key: "name",
    get: function get() {
      return "embed";
    }
  }, {
    key: "schema",
    get: function get() {
      var _this = this;

      return {
        content: "inline*",
        group: "block",
        atom: true,
        attrs: {
          href: {}
        },
        parseDOM: [{
          tag: "iframe[class=embed]",
          getAttrs: function getAttrs(dom) {
            var embeds = _this.editor.props.embeds;
            var href = dom.getAttribute("src") || "";

            if (embeds) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = embeds[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var embed = _step2.value;
                  var matches = embed.matcher(href);

                  if (matches) {
                    return {
                      href: href
                    };
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }

            return {};
          }
        }],
        toDOM: function toDOM(node) {
          return ["iframe", {
            class: "embed",
            src: node.attrs.href,
            contentEditable: false
          }, 0];
        }
      };
    }
  }, {
    key: "rulePlugins",
    get: function get() {
      return [embeds_1.default(this.options.embeds)];
    }
  }]);

  return Embed;
}(Node_1.default);

exports.default = Embed;